import PublicLayout from '@/components/public/PublicLayout';
import ContactForm from '@/components/public/ContactForm';
import LocationContact from '@/components/public/LocationContact';

export default function ContactoPage() {
    return (
        <PublicLayout>
            <section className="relative overflow-hidden bg-gradient-fun text-white py-16 sm:py-20">
                <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full bg-[hsl(var(--kche-yellow))]/30 blur-3xl" />
                <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <p className="text-sm font-bold font-display text-[hsl(var(--kche-yellow))] uppercase tracking-wider">Contacto</p>
                    <h1 className="mt-1 text-4xl sm:text-5xl lg:text-6xl font-display font-bold leading-tight">Estamos para <span className="text-[hsl(var(--kche-yellow))]">ayudarte</span></h1>
                    <p className="mt-4 max-w-2xl text-lg">Envíanos un mensaje y te contactaremos lo antes posible.</p>
                </div>
            </section>
            <LocationContact withMap />
            <section className="bg-kche-soft py-14">
                <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
                    <div className="rounded-3xl bg-white border border-border shadow-soft p-6 sm:p-8">
                        <h3 className="text-2xl font-display font-bold">¿Tienes una consulta?</h3>
                        <p className="mt-1 text-sm text-muted-foreground">Escríbenos y te contactaremos pronto.</p>
                        <div className="mt-6"><ContactForm /></div>
                    </div>
                </div>
            </section>
        </PublicLayout>
    );
}
